import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import { marketingColors as C } from '../../theme_landing_page';
import { cover, getCategory } from '../data';
import type { Article } from '../data/types';

const ArticleCard: React.FC<{ article: Article }> = ({ article }) => {
  const cat = getCategory(article.category);
  return (
    <Box component={RouterLink} to={`/blog/${article.slug}`} sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box sx={{ borderRadius: '24px', overflow: 'hidden', aspectRatio: '16/11', position: 'relative', background: C.panel }}>
        <Box component="img" loading="lazy" src={cover(article)} alt={article.title} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <Box
          sx={{
            position: 'absolute',
            top: 14,
            left: 14,
            background: C.white,
            color: C.accent,
            borderRadius: '32px',
            padding: '5px 12px',
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: '0.06rem',
            textTransform: 'uppercase',
          }}
        >
          {cat?.name || article.category}
        </Box>
      </Box>
      <Box>
        <Box component="h3" sx={{ fontSize: 19, fontWeight: 500, lineHeight: 1.35, margin: 0 }}>
          {article.title}
        </Box>
        <Box
          sx={{
            marginTop: '8px',
            color: C.body,
            fontSize: 14.5,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {article.description}
        </Box>
        <Box sx={{ marginTop: '12px', fontSize: 12.5, color: C.muted }}>{article.readingMinutes} min read</Box>
      </Box>
    </Box>
  );
};

export default ArticleCard;
